module.exports = __webpack_public_path__ + "cd36d6ad5c4b05306b9ce7e18cd31a88.svg";